import { sortByTitle } from 'app/common/lib/sort'
import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { useVendingExternalServices } from 'app/dataProviders/VendingDataProvider/externalServices'
import React, { useCallback, useMemo } from 'react'
import type { ItemType } from 'app/common/ui-next/plain-selector/types'
import { OptionProp, OptionProps } from 'app/common/ui-next/option-props'
import { RowLayoutContent } from 'app/common/layouts/RowLayout'
import styles from './ExternalServicesSelector.module.scss'
import { VendingMachineExternalServiceSettings } from 'app/dataTypes/vending/machine/externalServices'
import { ID, UNUSED_EXTERNAL_SERVICE_ID } from './predefined-ids'

const unusedExternalServiceItem = { id: UNUSED_EXTERNAL_SERVICE_ID, title: 'Не используется' }

interface Props {
  machineId: number
  machineExtService: VendingMachineExternalServiceSettings[]
  selectedExternalService: string[]
  disabled: boolean
  loadingMachineServices: boolean
  onModify: (values: string[]) => void
}
export const ExternalServicesSelector = ({
  machineId,
  machineExtService,
  selectedExternalService,
  disabled,
  loadingMachineServices,
  onModify,
}: Props) => {
  const { data: services, loading: loadingVendingServices } = useVendingExternalServices()

  const servicesList = useMemo<Array<ItemType>>(
    () => [
      unusedExternalServiceItem,
      ...sortByTitle(
        Object.values(services).map(({ serviceId, title }) => ({ id: String(serviceId), title })),
      ),
    ],
    [services],
  )

  const changeCurrentService = useCallback(
    (values: string[]) => {
      onModify(values)
    },
    [onModify],
  )

  const activeSavedService = machineExtService.find(({ active }) => active)

  const loading = loadingVendingServices || loadingMachineServices
  return (
    <div>
      <PlainItemsSelector
        id={ID.externalService}
        label="Внешние сервисы"
        header="Выберите внешний сервис"
        pleaseSelectText="Выберите сервис"
        items={servicesList}
        selection={selectedExternalService}
        defaultSelection={selectedExternalService}
        loading={loading}
        onChange={changeCurrentService}
        selectedAllOnEmptySelection={false}
        disabled={disabled || loading}
      />
      <OptionProps>
        <OptionProp title="Идентификатор аппарата" loading={loading}>
          {machineId}
        </OptionProp>
      </OptionProps>
      <RowLayoutContent className={styles.props} paddingfree>
        <React.Fragment>
          <OptionProps>
            <OptionProp title="Статус" loading={loading}>
              {activeSavedService ? 'Активен' : 'Не активен'}
            </OptionProp>
          </OptionProps>
        </React.Fragment>
      </RowLayoutContent>
    </div>
  )
}
